import { defineStore } from "pinia";
import { RBACclient, setBrandId } from "@/apiClient";
import { urls } from "../modules/UserManagement/urls";
import { useMerchantsStore } from "@/stores/merchants";
import { useTimeZoneStore } from "@/stores/timezone"
import { usePermissionStore } from "@/stores/permissions";

export const useBrandsStore = defineStore("brands", {
  state: () => ({
    brands: [],
    selectedBrandUri:null,
    brandsLoading: true,
  }),
  getters: {
    selectedBrandId() {
      return this.selectedBrand?.id;
    },
    selectedBrand(store) {
      return store.brands.find((brand) => brand.uri === store.selectedBrandUri);
    },
  },
  actions: {
    async fetchBrands() {
      const { data } = await RBACclient.get(urls.getProfileBrands);
      this.brands = data.brands;
      if(this.selectedBrandUri) {
        this.setBrandUri(this.selectedBrandUri);
      }
      this.brandsLoading = false;
    },
    setBrandUri(uri) {
      const brand = this.brands.find((brand) => brand.uri === uri);
      if (brand) {
        setBrandId(brand);
        const permissionStore = usePermissionStore();
        permissionStore.fetchPermissions(brand.id, brand.flags.enableUserManagement);
        const merchantStore = useMerchantsStore();
        merchantStore.fetchMerchants(brand.id);
        const timezoneStore = useTimeZoneStore();
        timezoneStore.fetchTimeZone(brand.id);
      }
      this.selectedBrandUri = uri;
    },
    async deassignManager(brandId) {
      try {
        // await RBACclient.delete(iamUrls.deleteProfileBrands(brandId));
        // this.brands = this.brands.filter(b => b.id !== brandId);
      } catch (error) {
        console.error(error);
      }
    },
  },
});
